import Vue from 'vue'
import Router from 'vue-router'
import Controller from './controller.js'
import EsqueciSenha from '@/components/autenticacao/EsqueciSenha'
import Login from '@/components/autenticacao/Login'
import RecuperarSenha from '@/components/autenticacao/RecuperarSenha'
import Portal from '@/components/portal/Portal'
import ErroPaginaNaoEncontrada from '@/components/paginas-erro/ErroPaginaNaoEncontrada'
import Usuarios from '@/components/usuarios/Usuarios'
import CadastroUsuario from '@/components/usuarios/CadastroUsuario'
import Contas from '@/components/conta/Contas'
import CadastroConta from '@/components/conta/CadastroConta'
import Empresas from '@/components/clientes/Empresas'
import CadastroEmpresa from '@/components/clientes/CadastroEmpresa'
import StatusEmpresa from '@/components/clientes/StatusEmpresa'
import Origens from '@/components/origem/Origens'
import CadastroOrigem from '@/components/origem/CadastroOrigem'
import Segmentos from '@/components/segmento/Segmentos'
import CadastroSegmento from '@/components/segmento/CadastroSegmento'
import Pessoas from '@/components/clientes/Pessoas'
import PessoasAniversariantes from '@/components/clientes/PessoasAniversariantes'
import CadastroPessoa from '@/components/clientes/CadastroPessoa'
import Agendas from '@/components/agenda/Agendas'
import AgendaLista from '@/components/agenda/AgendaLista'
import NegociosEmpresa from '@/components/negocio/NegociosEmpresa'
import NegociosPessoa from '@/components/negocio/NegociosPessoa'
import NegociosPessoaPosVenda from '@/components/negocio/NegociosPessoaPosVenda'
import NegociosPessoaPrimeiroContato from '@/components/negocio/NegociosPessoaPrimeiroContato'
import DocumentosEmpresa from '@/components/documento/DocumentosEmpresa'
import DocumentosPessoa from '@/components/documento/DocumentosPessoa'
import Produtos from '@/components/produto/Produtos'
import CadastroProduto from '@/components/produto/CadastroProduto'
import Caixa from '@/components/caixa/Caixa'
import EditarCaixa from '@/components/caixa/EditarCaixa'
import HistoricoCaxia from '@/components/caixa/Historico'
import Despesas from '@/components/despesa/Despesas'
import CadastroDespesa from '@/components/despesa/CadastroDespesa'
import CaixaDiario from '@/components/relatorio/CaixaDiario'
import CaixaDiarioCompleto from '@/components/relatorio/CaixaDiarioCompleto'
import CaixaMensal from '@/components/relatorio/CaixaMensal'
import CustoDiario from '@/components/relatorio/CustoDiario'
import CustoMensal from '@/components/relatorio/CustoMensal'
import ProdutosMaisVendidos from '@/components/relatorio/ProdutosMaisVendidos'
import CustoVSReceita from '@/components/relatorio/CustoVSReceita'
import VendasSite from '@/components/caixa/VendasSite'
import TipoDespesas from '@/components/tipodespesa/TipoDespesas'
import CadastroTipoDespesa from '@/components/tipodespesa/CadastroTipoDespesa'
import StatusPessoa from '@/components/clientes/StatusPessoa'
import Download from '@/components/clientes/Download'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false, mostraSideMenu: false }
    },
    {
      path: '/',
      name: 'Portal',
      alias: '/portal',
      component: Portal,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/usuarios',
      name: 'Usuarios',
      component: Usuarios,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/usuario/cadastro',
      name: 'CadastroUsuario',
      component: CadastroUsuario,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/contas',
      name: 'Contas',
      component: Contas,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/conta/cadastro',
      name: 'CadastroConta',
      component: CadastroConta,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/clientes/empresas',
      name: 'Empresas',
      component: Empresas,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/clientes/cadastro/empresas',
      name: 'CadastroEmpresa',
      component: CadastroEmpresa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/clientes/StatusEmpresa',
      name: 'StatusEmpresa',
      component: StatusEmpresa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/clientes/pessoas',
      name: 'Pessoas',
      component: Pessoas,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/clientes/aniversariantes',
      name: 'PessoasAniversariantes',
      component: PessoasAniversariantes,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/clientes/cadastro/pessoas',
      name: 'CadastroPessoa',
      component: CadastroPessoa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/clientes/StatusPessoa',
      name: 'StatusPessoa',
      component: StatusPessoa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/origem',
      name: 'Origens',
      component: Origens,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/origem/Cadastro',
      name: 'CadastroOrigem',
      component: CadastroOrigem,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/segmento',
      name: 'Segmentos',
      component: Segmentos,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/segmento/Cadastro',
      name: 'CadastroSegmento',
      component: CadastroSegmento,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/agenda/Agendas',
      name: 'Agendas',
      component: Agendas,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/agenda/Lista',
      name: 'AgendaLista',
      component: AgendaLista,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/Negocios/Empresa',
      name: 'NegociosEmpresa',
      component: NegociosEmpresa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/Negocios/Pessoa',
      name: 'NegociosPessoa',
      component: NegociosPessoa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/Negocios/Pessoa/PrimeiroContato',
      name: 'NegociosPessoaPrimeiroContato',
      component: NegociosPessoaPrimeiroContato,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/Negocios/Pessoa/PosVenda',
      name: 'NegociosPessoaPosVenda',
      component: NegociosPessoaPosVenda,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/documento/Empresa',
      name: 'DocumentosEmpresa',
      component: DocumentosEmpresa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/documento/Pessoa',
      name: 'DocumentosPessoa',
      component: DocumentosPessoa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/Produtos',
      name: 'Produtos',
      component: Produtos,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/produto/cadastro',
      name: 'CadastroProduto',
      component: CadastroProduto,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/caixa/Historico',
      name: 'HistoricoCaxia',
      component: HistoricoCaxia,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/caixa',
      name: 'Caixa',
      component: Caixa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/caixa/editar',
      name: 'EditarCaixa',
      component: EditarCaixa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/despesas',
      name: 'Despesas',
      component: Despesas,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/despesa/cadastro',
      name: 'CadastroDespesa',
      component: CadastroDespesa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/relatorio/caixamensal',
      name: 'CaixaMensal',
      component: CaixaMensal,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/relatorio/caixadiario',
      name: 'CaixaDiario',
      component: CaixaDiario,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/relatorio/caixadiariocompleto',
      name: 'CaixaDiarioCompleto',
      component: CaixaDiarioCompleto,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/relatorio/customensal',
      name: 'CustoMensal',
      component: CustoMensal,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/relatorio/custodiario',
      name: 'CustoDiario',
      component: CustoDiario,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/relatorio/produtosmaisvendidos',
      name: 'ProdutosMaisVendidos',
      component: ProdutosMaisVendidos,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/relatorio/custovsreceita',
      name: 'CustoVSReceita',
      component: CustoVSReceita,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/vendassite',
      name: 'VendasSite',
      component: VendasSite,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/tipodespesas',
      name: 'TipoDespesas',
      component: TipoDespesas,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/tipodespesa/cadastro',
      name: 'CadastroTipoDespesa',
      component: CadastroTipoDespesa,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/clientes/download',
      name: 'Download',
      component: Download,
      meta: { requiresAuth: true, mostraSideMenu: true }
    },
    {
      path: '/RecuperarSenha/:token',
      name: 'RecuperarSenha',
      meta: { title: 'Recuperação de Senha', navbartitle: 'Recuperação de Senha', requiresAuth: false },
      component: RecuperarSenha
    },
    {
      path: '/EsqueciSenha',
      name: 'EsqueciSenha',
      meta: { title: 'Recuperação de Senha', navbartitle: 'Recuperação de Senha', requiresAuth: false, hideLogin: true },
      component: EsqueciSenha
    },
    {
      path: "*",
      name: 'ErroPaginaNaoEncontrada',
      component: ErroPaginaNaoEncontrada
    }

  ],
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  Controller.auth(to, from, next);
  Controller.permissaoAcesso(to, from, next);

  document.title = `Budim - ${to.name}`
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js